import { render, staticRenderFns } from "./GridWidgetCustomizer.vue?vue&type=template&id=a7fbca48&"
import script from "./GridWidgetCustomizer.vue?vue&type=script&lang=js&"
export * from "./GridWidgetCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./GridWidgetCustomizer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports